export default {
  title: '商戶管理',
  companyInfo: '企業信息',
  emailConfig: '郵箱配置',
  smsConfig: '短信配置',
  i18nManagement: '多語言管理',
  paymentAuthConfig: '支付與授權配置',
  systemSettings: '系統設置',
  roleManagement: '角色管理',
  accountManagement: '賬號管理',
  operationLog: '操作日誌',
  companyName: '公司名稱',
  companyNameReadonly: '企業信息',
  companyNameReadonlyTip: '輸入該語言環境下的公司展示名稱',
  companyLogo: '公司 Logo',
  companyLogoTip: '限制圖片格式（JPG、PNG）和大小（不超過5MB），上傳後顯示縮略圖並支持替換',
  companyLocaleLabel: '公司資料',
  companyEmail: '公司郵箱',
  companyEmailPlaceholder: '請輸入公司郵箱',
  companyPhone: '公司電話',
  companyPhonePlaceholder: '請輸入聯繫電話',
  companyAddress: '公司地址',
  companyAddressPlaceholder: '請輸入公司地址',
  companyIntro: '公司介紹',
  companyIntroPlaceholder: '請輸入公司介紹',
  save: '保存',
  saveSuccess: '保存成功',
  uploadSuccess: '上傳成功',
  uploadFail: '上傳失敗',
  logoFormatError: '僅支持 JPG、PNG 格式圖片',
  logoSizeError: '圖片大小不能超過 5MB',
  locale_zh_TW: '繁體中文',
  locale_zh_CN: '简体中文',
  locale_en_US: 'English',
  locale_ja_JP: 'Japanese',
};
